/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const ko_discover_logs_refetchingtab1 = /** @type {(inputs: { tab: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.tab} 탭 새로고침 중...`)
};

const en_discover_logs_refetchingtab1 = /** @type {(inputs: { tab: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Refreshing ${i?.tab} tab...`)
};

const ja_discover_logs_refetchingtab1 = /** @type {(inputs: { tab: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.tab}タブを更新中...`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ tab: NonNullable<unknown> }} inputs
* @param {{ locale?: "ko" | "en" | "ja" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
const discover_logs_refetchingtab1 = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.discover_logs_refetchingtab1(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("discover_logs_refetchingtab1", locale)
	if (locale === "ko") return ko_discover_logs_refetchingtab1(inputs)
	if (locale === "en") return en_discover_logs_refetchingtab1(inputs)
	return ja_discover_logs_refetchingtab1(inputs)
};
export { discover_logs_refetchingtab1 as "discover_logs_refetchingTab" }